export default defineAppConfig({
	version: '155',
	//host: 'https://...',
	lang: 'hr',
	multiHost: [], // Multidomain configuration
	multilanguage: false,
	api: 'hapi',
	apiVersion: 'v1',
	keycloak: false,
	idleReloadTimeout: 60000 * 15, // reload page after x miliseconds of inactivity, 0 to disable (default 15 minutes)
	thumbPresets: {}, // deprecated
	cache: {
		debug: false,
		enabled: process.env.NODE_ENV == 'development' ? false : true,
		// TTL in minutes; 0 keeps the 10-minute fallback, false disables that cache.
		// Includes endpoints; token remains cached for server authentication. See docs/specs/server-cache.md.
		refresh: {
			currency: 1440,
			endpoints: 1440,
			info: 1440,
			labels: 5,
			menus: 5,
			redirects: 5,
			rotators: 5,
			routes: 5,
			token: 1440,
			newsletter: 1440,
			gdprTemplate: 1440,
			thumbs: 5,
			cmsPages: 10,
			catalogCategories: 5,
			catalogLists: 5,
			catalogManufacturers: 5,
			catalogProduct: 5,
			catalogProducts: 5,
			catalogSellers: 5,
			faqCategories: 5,
			faqQuestions: 5,
			faqQuestion: 5,
			publishCategories: 5,
			publishPost: 5,
			publishPosts: 5,
			publishAuthors: 5,
			locationPoints: 5,
			locationPoint: 5,
			events: 5,
			event: 5,
			staticContent: 5,
		},
	},
	meta: {
		viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
	},
	/*
	hooks: {
		checkAccess: data => {} // callback function to check access to content (staff, standard user...)
	},
	*/
	facebook: {
		pixel: {
			env: ['production'],
			apiKey: '',
			target: 'head',
			gdpr: 'analytics',
		},
		conversionApi: {
			env: ['production'],
			debug: false,
			eventTestCode: '',
			events: [], // 'pageView', 'search', 'contact', 'viewContent', 'addToWishlist', 'addToCart', 'addPaymentInfo', 'completeRegistration', 'customizeProduct', 'findLocation', 'initiateCheckout', 'subscribe', 'purchase'
			gdpr: 'analytics',
			/*
				pageView: {
					name: 'PageView',
					data: ['title'],
				},
			*/
		},
	},
	google: {
		gtm: {
			env: ['production'],
			gdpr: false,
			code: '',
		},
		tracking: {
			gdpr: 'analytics',
			debug: false,
			affiliation: '',
			events: [], // 'gdprConsents', 'pageView', 'viewItem', 'viewItemList', 'selectItem', 'viewCart', 'removeProduct', 'addProduct', 'login', 'beginCheckout', 'addShippingInfo', 'addPaymentInfo', 'purchase', 'refund', 'addToWishlist', 'viewPromotion', 'selectPromotion'
			/*
				hooks: {
					mapProduct(data) {},
				},
				pageView: {
					name: 'page_view',
					hooks: {
						mapData(data) {},
					},
				},
			*/
		},
		remarketing: {
			env: ['production'],
			gdpr: 'marketing',
			debug: false,
			// swapItemIds: true, // swap id and code values
			// conversionId: '',
			gtm: true,
			events: [], // 'home', 'searchresults', 'category', 'offerdetail', 'conversionintent', 'conversion', 'other'
			/*
			offerdetail: {
				data: [], // pagetype, id, code, total
			},
			*/
		},
		ga4: {
			env: ['production'],
			gdpr: 'analytics',
		},
	},
	hapi: {
		tracking: {
			debug: false,
			events: ['publish', 'catalogproduct'], // catalogproduct, catalogcategory, cataloglist, catalogmanufacturer, publish, publishcategory, page. Publish and catalog product ade always allowed - admin views tracking
		},
	},
	sentryTracking: {
		maskKeys: [
			'address',
			'authorization',
			'b_address',
			'b_city',
			'b_company_address',
			'b_company_city',
			'b_company_name',
			'b_company_oib',
			'b_country',
			'b_email',
			'b_first_name',
			'b_fullname',
			'b_house_number',
			'b_last_name',
			'b_location',
			'b_phone',
			'b_zipcode',
			'city',
			'company',
			'company_name',
			'cookie',
			'email',
			'first_name',
			'firstname',
			'full_name',
			'fullname',
			'house_number',
			'last_name',
			'lastname',
			'location',
			'mobile',
			'name',
			'oib',
			'password',
			'phone',
			'postcode',
			'street',
			'surname',
			'telephone',
			'token',
			'zipcode',
		],
		hapiErrors: {
			includeUrls: [], // When empty, every useApi request is eligible. String patterns match by substring; "*" is supported.
			excludeUrls: [],
		},
	},
	/*
		compare: {
			limit: 5 // limit number of items in compare list
		},
		layouts: [],
		structuredData: {
			basic: {
				name: 'Site Name',
				organizationName: 'Company Name',
				logo: '',
				phone: '',
				email: '',
				socialNetworkUrls: '',
			},
		},
	*/
	fetchApi: {
		// Only verified read operations receive a timeout and one retry on timeout.
		safeRequests: {
			enabled: true,
			timeout: 10000, // First attempt only; retry has no automatic timeout
			retryDelay: 500,
			endpoints: [
				{method: 'POST', endpoint: '_post_hapi_catalog_categories'},
				{method: 'POST', path: '/api/nuxtapi/catalog/categories/'},
				{method: 'POST', endpoint: '_post_hapi_catalog_manufacturers'},
				{method: 'POST', path: '/api/nuxtapi/catalog/manufacturers/'},
				{method: 'POST', endpoint: '_post_hapi_catalog_sellers'},
				{method: 'POST', path: '/api/nuxtapi/catalog/sellers/'},
				{method: 'POST', endpoint: '_post_hapi_catalog_lists'},
				{method: 'POST', path: '/api/nuxtapi/catalog/lists/'},
				{method: 'POST', endpoint: '_post_hapi_catalog_products'},
				{method: 'POST', path: '/api/nuxtapi/catalog/products/'},
				{method: 'POST', endpoint: '_post_hapi_catalog_products_price_qty'},
				{method: 'POST', endpoint: '_post_hapi_publish_categories'},
				{method: 'POST', path: '/api/nuxtapi/publish/categories/'},
				{method: 'POST', endpoint: '_post_hapi_publish_authors'},
				{method: 'POST', path: '/api/nuxtapi/publish/authors/'},
				{method: 'POST', endpoint: '_post_hapi_publish_publishes'},
				{method: 'POST', path: '/api/nuxtapi/publish/posts/'},
				{method: 'POST', endpoint: '_post_hapi_search_autocomplete'},
				{method: 'POST', path: '/api/nuxtapi/catalog/product/'},
				{method: 'POST', path: '/api/nuxtapi/publish/post/'},
			],
		},
		put: {
			appendLang: true,
		},
		post: {
			appendLang: true,
		},
	},
	catalog: {
		redirectEmptySearch: false, // Redirect an empty search on the catalog root to the same URL without search_q
		updatePriceQty: false, // If there are user specific prices, fetch and update products price and qty
		quickOrder: false, // enable/disable quick order template
		productsResponseFields: [], // global response fields for products
		listsResponseFields: [], // global response fields for lists
		manufacturersResponseFields: [], // global response fields for manufacturers
		/*
		fetch: {} // extra fetch options for product detail
		fetchCategories: {} // extra fetch options for product categories
		fetchLists: {} // extra fetch options for products list
		fetchManufacturers: {} // extra fetch options for brands detail
		hooks: {
			mapProduct: product => {} // callback function to modify product detail data once fetched
			mapProducts: products => {} // callback function to modify products data once fetched (for example to remove some unnecessary payload data)
		}
		*/
	},
	publish: {
		postsResponseFields: [], // global response fields for posts
	},
	auth: {
		dashboard: null, // redirect from user dashboard to different page. For example list of orders - 'auth_my_webshoporder',
		loggedOutRedirect: 'auth_login', // redirect user to this page if logged out and trying to access auth page. "appUrls" key needs to be used.
		loggedInRedirect: 'auth', // redirect user to this page if logged in and trying to access login or signup page. "appUrls" key needs to be used.
	},
	webshop: {
		auth: true, // enable/disable webshop auth
		//steps: ['customer', 'shipping', 'payment', 'reviewOrder'], // if step is not defined, route will be removed and template will not be rendered
	},
	viewOrder: {
		orderNumber: '%order_number%', // order number format. For example '%order_number% / %order_id%'
		orderPaymentTransfer: true,
		itemEanCode: true,
		footerLabels: false, // show staff footer labels (pripremio, pakirao, predao kuriru...)
		warehouse: {
			enabled: false, // show warehouse info on order page
			permission: null, // restrict access to warehouse info by user role (staff, superuser, developer)
			includeEmpty: true, // show warehouses with no items
		},
	},
	hapiEndpoints: {
		'_put_hapi_auth_api_company': '/hapi/latest/auth/api-company/',
		'_post_hapi_auth_api_user': '/hapi/latest/auth/api-user/',
		'_put_hapi_auth_api_user': '/hapi/latest/auth/api-user/',
		'_delete_hapi_auth_api_user': '/hapi/latest/auth/api-user/',
		'_get_hapi_auth_store': '/hapi/latest/auth/store/',
		'_put_hapi_auth_store': '/hapi/latest/auth/store/',
		'_post_hapi_auth_loyalty': '/hapi/latest/auth/loyalty/',
		'_get_hapi_auth_generate_token': '/hapi/latest/auth/generate-token/',
		'_get_hapi_auth_export_orders': '/hapi/latest/auth/export-orders/',
		'_get_hapi_auth_is_login': '/hapi/latest/auth/is-login/',
		'_post_hapi_auth_login': '/hapi/latest/auth/login/',
		'_post_hapi_auth_login_api': '/hapi/latest/auth/login-api/',
		'_post_hapi_auth_logout': '/hapi/latest/auth/logout/',
		'_post_hapi_auth_logout_api': '/hapi/latest/auth/logout-api/',
		'_post_hapi_auth_api_config': '/hapi/latest/auth/api-config/',
		'_post_hapi_auth_update_customer_data': '/hapi/latest/auth/update-customer-data/',
		'_post_hapi_auth_signup': '/hapi/latest/auth/signup/',
		'_post_hapi_auth_signup_b2c_initial': '/hapi/latest/auth/signup-b2c-initial/',
		'_post_hapi_auth_signup_b2c_final': '/hapi/latest/auth/signup-b2c-final/',
		'_post_hapi_auth_signup_b2b_initial': '/hapi/latest/auth/signup-b2b-initial/',
		'_post_hapi_auth_signup_b2b_final': '/hapi/latest/auth/signup-b2b-final/',
		'_get_hapi_auth_hybridauth': '/hapi/latest/auth/hybridauth/?provider=%PROVIDER%',
		'_post_hapi_auth_signup_quick': '/hapi/latest/auth/signup-quick/',
		'_get_hapi_auth_signup_confirm': '/hapi/latest/auth/signup-confirm/%ID%-%CODE%/',
		'_post_hapi_auth_forgotten_password': '/hapi/latest/auth/forgotten-password/',
		'_post_hapi_auth_forgotten_password_api': '/hapi/latest/auth/forgotten-password-api/',
		'_get_hapi_auth_forgotten_password_check': '/hapi/latest/auth/forgotten-password-check/%ID%-%CODE%/',
		'_post_hapi_auth_new_password': '/hapi/latest/auth/new-password/',
		'_post_hapi_auth_change_password': '/hapi/latest/auth/change-password/',
		'_get_hapi_auth_profile': '/hapi/latest/auth/profile/',
		'_post_hapi_auth_profile': '/hapi/latest/auth/profile/',
		'_get_hapi_auth_my_comments': '/hapi/latest/auth/my-comments/',
		'_get_hapi_auth_my_webshoporder': '/hapi/latest/auth/my-webshoporder/',
		'_get_hapi_auth_my_webshopcoupon': '/hapi/latest/auth/my-webshopcoupon/',
		'_post_hapi_auth_my_webshopcoupon': '/hapi/latest/auth/my-webshopcoupon/',
		'_delete_hapi_auth_my_webshopcoupon': '/hapi/latest/auth/my-webshopcoupon/',
		'_get_hapi_auth_my_tracking_events': '/hapi/latest/auth/my-tracking-events/',
		'_put_hapi_auth_my_tracking_event': '/hapi/latest/auth/my-tracking-event/%ID%/',
		'_delete_hapi_auth_my_tracking_event': '/hapi/latest/auth/my-tracking-event/',
		'_get_hapi_auth_my_tracking_event_unread_count': '/hapi/latest/auth/my-tracking-event-unread-count/',
		'_post_hapi_auth_delivery_address': '/hapi/latest/auth/delivery-address/',
		'_delete_hapi_auth_delivery_address': '/hapi/latest/auth/delivery-address/',
		'_put_hapi_auth_delivery_address': '/hapi/latest/auth/delivery-address/%ID%/',
		'_post_hapi_auth_default_address': '/hapi/latest/auth/default-address/',
		'_put_hapi_auth_user_group': '/hapi/latest/auth/user-group/%ID%/',
		'_get_hapi_auth_all_cart_snippet': '/hapi/latest/auth/cart-snippet/',
		'_post_hapi_auth_cart_snippet': '/hapi/latest/auth/cart-snippet/',
		'_delete_hapi_auth_cart_snippet': '/hapi/latest/auth/cart-snippet/',
		'_get_hapi_auth_cart_snippet': '/hapi/latest/auth/cart-snippet/%ID%/',
		'_put_hapi_auth_cart_snippet': '/hapi/latest/auth/cart-snippet/%ID%/',
		'_delete_hapi_auth_delete_cart_snippet_product': '/hapi/latest/auth/cart-snippet-product/',
		'_get_hapi_child_profiles': '/hapi/latest/child/profiles/',
		'_post_hapi_child_profile': '/hapi/latest/child/profile/',
		'_delete_hapi_child_profile': '/hapi/latest/child/profile/',
		'_get_hapi_child_profile': '/hapi/latest/child/profile/%ID%/',
		'_put_hapi_child_profile': '/hapi/latest/child/profile/%ID%/',
		'_get_hapi_configurator_get_data': '/hapi/latest/configurator/get-data/',
		'_post_hapi_configurator_init': '/hapi/latest/configurator/init/',
		'_post_hapi_configurator_next_step': '/hapi/latest/configurator/next-step/',
		'_post_hapi_publish_categories': '/hapi/latest/publish/categories/',
		'_post_hapi_publish_authors': '/hapi/latest/publish/authors/',
		'_post_hapi_publish_lists': '/hapi/latest/publish/lists/',
		'_post_hapi_publish_publishes': '/hapi/latest/publish/publishes/',
		'_get_hapi_publish_publish': '/hapi/latest/publish/publish/%ID%/',
		'_post_hapi_tag_tags': '/hapi/latest/tag/tags/',
		'_get_hapi_feedback_comments': '/hapi/latest/feedback/comments/%CONTENT_TYPE%-%ID%-%LANG%/',
		'_post_hapi_feedback_comment': '/hapi/latest/feedback/comment/',
		'_get_hapi_feedback_rates': '/hapi/latest/feedback/rates/%CONTENT_TYPE%-%ID%-%LANG%/',
		'_post_hapi_feedback_rate': '/hapi/latest/feedback/rate/',
		'_post_hapi_feedback_rate_comment': '/hapi/latest/feedback/rate-comment/',
		'_get_hapi_feedback_comment_form': '/hapi/latest/feedback/form/comment/',
		'_get_hapi_feedback_notifyme_form': '/hapi/latest/feedback/form/notifyme/',
		'_post_hapi_feedback_notifyme': '/hapi/latest/feedback/notifyme/',
		'_get_hapi_gdpr_form': '/hapi/latest/gdpr/form/%TEMPLATE%/',
		'_get_hapi_gdpr_consents': '/hapi/latest/gdpr/consents/',
		'_post_hapi_gdpr_consents': '/hapi/latest/gdpr/consents/',
		'_get_hapi_siteform_form': '/hapi/latest/siteform/form/%TYPE%/',
		'_post_hapi_siteform_form': '/hapi/latest/siteform/form/',
		'_get_hapi_misc_routes': '/hapi/latest/misc/routes/',
		'_get_hapi_misc_language': '/hapi/latest/misc/language/',
		'_post_hapi_misc_barcode': '/hapi/latest/misc/barcode/',
		'_get_hapi_misc_info': '/hapi/latest/misc/info/',
		'_get_hapi_misc_is_maintenance': '/hapi/latest/misc/is-maintenance/',
		'_get_hapi_misc_is_rate_limiter_exceeded': '/hapi/latest/misc/is-rate-limiter-exceeded/',
		'_get_hapi_misc_health_check': '/hapi/latest/misc/health-check/',
		'_get_hapi_misc_db_health_check': '/hapi/latest/misc/db-health-check/',
		'_get_hapi_misc_tracking': '/hapi/latest/misc/tracking/',
		'_post_hapi_misc_tracking': '/hapi/latest/misc/tracking/',
		'_post_hapi_misc_log': '/hapi/latest/misc/log/',
		'_post_hapi_error_log': '/hapi/latest/misc/error-log/',
		'_get_hapi_staticcontent_pages': '/hapi/latest/staticcontent/pages/',
		'_post_hapi_staticcontent_pages': '/hapi/latest/staticcontent/pages/',
		'_post_hapi_faq_categories': '/hapi/latest/faq/categories/',
		'_post_hapi_faq_questions': '/hapi/latest/faq/questions/',
		'_get_hapi_faq_question': '/hapi/latest/faq/question/%ID%/',
		'_get_hapi_cms_labels': '/hapi/latest/cms/labels/',
		'_get_hapi_cms_pages': '/hapi/latest/cms/pages/',
		'_get_hapi_cms_menus': '/hapi/latest/cms/menu/',
		'_get_hapi_cms_redirect': '/hapi/latest/cms/redirect/',
		'_get_hapi_cms_redirects': '/hapi/latest/cms/redirects/',
		'_get_hapi_rotator_elements': '/hapi/latest/rotator/elements/',
		'_post_hapi_rotator_elements': '/hapi/latest/rotator/elements/',
		'_get_hapi_customer_validation_types': '/hapi/latest/customer/validation-types/',
		'_get_hapi_customer_fields_types': '/hapi/latest/customer/field-types/',
		'_get_hapi_customer_fields': '/hapi/latest/customer/fields/',
		'_get_hapi_customer': '/hapi/latest/customer/',
		'_post_hapi_customer': '/hapi/latest/customer/',
		'_put_hapi_customer': '/hapi/latest/customer/',
		'_put_hapi_customer_address_list': '/hapi/latest/customer/address-list/',
		'_post_hapi_customer_select_user': '/hapi/latest/customer/select-user/',
		'_delete_hapi_customer_select_user': '/hapi/latest/customer/select-user/',
		'_post_hapi_customer_select_parcel_user': '/hapi/latest/customer/select-parcel-user/',
		'_post_hapi_events': '/hapi/latest/event/events/',
		'_get_hapi_event': '/hapi/latest/event/events/%ID%/',
		'_post_hapi_location_points': '/hapi/latest/location/points/',
		'_get_hapi_location_point': '/hapi/latest/location/point/%ID%/',
		'_post_hapi_lottery_participate': '/hapi/latest/lottery/participate/',
		'_delete_hapi_lottery_participate': '/hapi/latest/lottery/participate/',
		'_get_hapi_webshop_is_cart_empty': '/hapi/latest/webshop/is-cart-empty/',
		'_post_hapi_webshop_cart_link': '/hapi/latest/webshop/cart-link/',
		'_get_hapi_webshop_check_giftwrapping': '/hapi/latest/webshop/check-giftwrapping/%ID%/',
		'_post_hapi_webshop_giftwrapping': '/hapi/latest/webshop/giftwrapping/',
		'_post_hapi_webshop_simple_giftwrapping': '/hapi/latest/webshop/simple-giftwrapping/',
		'_post_hapi_webshop_giftwrapping_note': '/hapi/latest/webshop/giftwrapping-note/',
		'_post_hapi_webshop_cart_order_type': '/hapi/latest/webshop/cart-order-type/',
		'_post_hapi_webshop_cart_order_type_options': '/hapi/latest/webshop/cart-order-type-options/',
		'_post_hapi_webshop_multiple_orders': '/hapi/latest/webshop/multiple-orders/',
		'_post_hapi_webshop_order_type': '/hapi/latest/webshop/order-type/',
		'_get_hapi_webshop_salesman_price_reasons': '/hapi/latest/webshop/salesman-price-reasons/',
		'_post_hapi_webshop_salesman_price': '/hapi/latest/webshop/salesman-price/',
		'_delete_hapi_webshop_salesman_price': '/hapi/latest/webshop/salesman-price/',
		'_post_hapi_webshop_salesman_definition_price': '/hapi/latest/webshop/salesman-definition-price/',
		'_delete_hapi_webshop_salesman_price_attachment': '/hapi/latest/webshop/salesman-price-attachment/',
		'_post_hapi_webshop_free_option': '/hapi/latest/webshop/free-option/',
		'_post_hapi_webshop_free_gift': '/hapi/latest/webshop/free-gift/',
		'_delete_hapi_webshop_free_gift': '/hapi/latest/webshop/free-gift/',
		'_post_hapi_webshop_partial_prepayment': '/hapi/latest/webshop/partial-prepayment/',
		'_delete_hapi_webshop_partial_prepayment': '/hapi/latest/webshop/partial-prepayment/',
		'_get_hapi_webshop_shipping_salesman_price_reasons': '/hapi/latest/webshop/shipping-salesman-price-reasons/',
		'_post_hapi_webshop_shipping_salesman_price': '/hapi/latest/webshop/shipping-salesman-price/',
		'_delete_hapi_webshop_shipping_salesman_price': '/hapi/latest/webshop/shipping-salesman-price/',
		'_delete_hapi_webshop_shipping_salesman_price_attachment': '/hapi/latest/webshop/shipping-salesman-price-attachment/',
		'_get_hapi_webshop_seller_info': '/hapi/latest/webshop/seller-info/',
		'_get_hapi_webshop_cart': '/hapi/latest/webshop/cart/',
		'_post_hapi_webshop_cart': '/hapi/latest/webshop/cart/',
		'_delete_hapi_webshop_cart': '/hapi/latest/webshop/cart/',
		'_get_hapi_webshop_cart_full': '/hapi/latest/webshop/cart/?item_detail=1',
		'_get_hapi_webshop_order_creation_in_progress': '/hapi/latest/webshop/order-creation-in-progress/',
		'_get_hapi_webshop_cart_total': '/hapi/latest/webshop/total/',
		'_get_hapi_webshop_multicart': '/hapi/latest/webshop/multicart/',
		'_post_hapi_webshop_cart_title': '/hapi/latest/webshop/cart-title/',
		'_post_hapi_webshop_cart_code': '/hapi/latest/webshop/cart-code/',
		'_post_hapi_webshop_current_cart_code': '/hapi/latest/webshop/current-cart-code/',
		'_post_hapi_webshop_current_cart_state': '/hapi/latest/webshop/current-cart-state/',
		'_get_hapi_webshop_imei_list': '/hapi/latest/webshop/imei-list/%CODE%/',
		'_post_hapi_webshop_cart_restore': '/hapi/latest/webshop/restore-cart/',
		'_post_hapi_webshop_latest_cart_state': '/hapi/latest/webshop/latest-cart-state/',
		'_post_hapi_webshop_product': '/hapi/latest/webshop/product/',
		'_put_hapi_webshop_product': '/hapi/latest/webshop/product/',
		'_delete_hapi_webshop_product': '/hapi/latest/webshop/product/',
		'_post_hapi_webshop_single_product': '/hapi/latest/webshop/single-product/',
		'_post_hapi_webshop_abandonment': '/hapi/latest/webshop/abandonment/',
		'_post_hapi_webshop_accept_new_product_price': '/hapi/latest/webshop/accept-new-product-price/',
		'_post_hapi_webshop_accept_base_product_price': '/hapi/latest/webshop/accept-base-product-price/',
		'_get_hapi_webshop_coupon': '/hapi/latest/webshop/coupon/',
		'_post_hapi_webshop_coupon': '/hapi/latest/webshop/coupon/',
		'_delete_hapi_webshop_coupon': '/hapi/latest/webshop/coupon/',
		'_get_hapi_webshop_country': '/hapi/latest/webshop/country/',
		'_get_hapi_webshop_location': '/hapi/latest/webshop/location/',
		'_get_hapi_webshop_location_point': '/hapi/latest/webshop/location-point/',
		'_get_hapi_webshop_payment': '/hapi/latest/webshop/payment/',
		'_get_hapi_webshop_order_status': '/hapi/latest/webshop/order-status/%ID%-%CODE%/',
		'_get_hapi_webshop_payment_check': '/hapi/latest/webshop/payment-check-0jhp9jas/',
		'_get_hapi_webshop_paymentstatus_aircash': '/hapi/latest/webshop/paymentstatus-aircash/',
		'_get_hapi_webshop_paymentstatus_bankart': '/hapi/latest/webshop/paymentstatus-bankart/',
		'_get_hapi_webshop_paymentstatus_bankart3': '/hapi/latest/webshop/paymentstatus-bankart3/',
		'_post_hapi_webshop_paymentstatus_braintree': '/hapi/latest/webshop/paymentstatus-braintree/',
		'_post_hapi_webshop_paymentstatus_paypal': '/hapi/latest/webshop/paymentstatus-paypal/',
		'_post_hapi_webshop_paymentstatus_kekspay': '/hapi/latest/webshop/paymentstatus-kekspay/',
		'_post_hapi_webshop_paymentstatus_monri': '/hapi/latest/webshop/paymentstatus-monri/',
		'_post_hapi_webshop_paymentstatus_monri2': '/hapi/latest/webshop/paymentstatus-monri2/',
		'_post_hapi_webshop_paymentstatus_mollie': '/hapi/latest/webshop/paymentstatus-mollie/',
		'_get_hapi_webshop_create_payment': '/hapi/latest/webshop/create-payment/%ID%-%CODE%/',
		'_put_hapi_webshop_prepare_bankart_payment': '/hapi/latest/webshop/prepare-bankart-payment/%ID%-%CODE%/',
		'_put_hapi_webshop_prepare_paymentgateway': '/hapi/latest/webshop/prepare-paymentgateway/%ID%-%CODE%/',
		'_put_hapi_webshop_order_prepare_paymentgateway': '/hapi/latest/webshop/order-prepare-paymentgateway/%ID%-%CODE%/',
		'_put_hapi_webshop_additionalpayment_prepare_paymentgateway': '/hapi/latest/webshop/additionalpayment-prepare-paymentgateway/%ID%-%CODE%/',
		'_get_hapi_webshop_cart_specific_paymentgateway_data': '/hapi/latest/webshop/cart-specific-paymentgateway-data/%TOKEN_ID%/',
		'_get_hapi_webshop_order_specific_paymentgateway_data': '/hapi/latest/webshop/order-specific-paymentgateway-data/%ID%-%CODE%/',
		'_get_hapi_webshop_additionalpayment_specific_paymentgateway_data': '/hapi/latest/webshop/additionalpayment-specific-paymentgateway-data/%ID%-%CODE%/',
		'_get_hapi_webshop_shipping': '/hapi/latest/webshop/shipping/',
		'_post_hapi_webshop_parcel_default_shipping': '/hapi/latest/webshop/parcel-default-shipping/',
		'_get_hapi_webshop_parcel_locker': '/hapi/latest/webshop/parcel-locker/',
		'_post_hapi_webshop_parcel_locker': '/hapi/latest/webshop/parcel-locker/',
		'_put_hapi_webshop_parcel_shipping': '/hapi/latest/webshop/parcel-shipping/',
		'_put_hapi_webshop_parcel_shipping_merge': '/hapi/latest/webshop/parcel-shipping/?merge=1',
		'_delete_hapi_webshop_single_cart': '/hapi/latest/webshop/single-cart/',
		'_get_hapi_webshop_payment_installments_info': '/hapi/latest/webshop/payment-installments-info/?item_id=%ITEM_ID%',
		'_post_hapi_webshoptrade_category': '/hapi/latest/webshoptrade/category/',
		'_post_hapi_webshoptrade_index_documents': '/hapi/latest/webshoptrade/documents/',
		'_post_hapi_webshoptrade_index_documents_by_group': '/hapi/latest/webshoptrade/documents-by-group/',
		'_post_hapi_webshoptrade_export_document_group_to_csv': '/hapi/latest/webshoptrade/export-document-group-to-csv/',
		'_get_hapi_webshoptrade_download_pdf': '/hapi/latest/webshoptrade/download-pdf/',
		'_post_hapi_customer_parcel_separate': '/hapi/latest/customer/parcel-separate/',
		'_post_hapi_customer_parcel_merge': '/hapi/latest/customer/parcel-merge/',
		'_post_hapi_customer_express_delivery': '/hapi/latest/customer/express-delivery/',
		'_post_hapi_customer_normal_delivery': '/hapi/latest/customer/normal-delivery/',
		'_post_hapi_webshop_order': '/hapi/latest/webshop/order/',
		'_post_hapi_webshop_photopay_order': '/hapi/latest/webshop/photopay-order/',
		'_get_hapi_webshop_order': '/hapi/latest/webshop/order/%ID%-%CODE%/',
		'_put_hapi_webshop_order': '/hapi/latest/webshop/order/%ID%-%CODE%/',
		'_get_hapi_webshop_additionalpayment': '/hapi/latest/webshop/additionalpayment/%ID%-%CODE%/',
		'_put_hapi_webshop_additionalpayment': '/hapi/latest/webshop/additionalpayment/%ID%-%CODE%/',
		'_get_hapi_webshop_additionalpayment_status': '/hapi/latest/webshop/additionalpayment-status/%ID%-%CODE%/',
		'_get_hapi_newsletter_form': '/hapi/latest/newsletter/form/%CODE%/',
		'_post_hapi_newsletter_subscribe': '/hapi/latest/newsletter/subscribe/',
		'_post_hapi_newsletter_subscribe_confirm': '/hapi/latest/newsletter/subscribe-confirm/',
		'_post_hapi_newsletter_unsubscribe': '/hapi/latest/newsletter/unsubscribe/',
		'_post_hapi_newsletter_unsubscribe_confirm': '/hapi/latest/newsletter/unsubscribe-confirm/',
		'_get_hapi_catalog_attributes': '/hapi/latest/catalog/attributes/',
		'_post_hapi_catalog_categories': '/hapi/latest/catalog/categories/',
		'_post_hapi_catalog_manufacturers': '/hapi/latest/catalog/manufacturers/',
		'_post_hapi_catalog_sellers': '/hapi/latest/catalog/sellers/',
		'_post_hapi_catalog_lists': '/hapi/latest/catalog/lists/',
		'_post_hapi_catalog_products': '/hapi/latest/catalog/products/',
		'_post_hapi_catalog_aircondition_products': '/hapi/latest/catalog/aircondition-products/',
		'_post_hapi_catalog_products_price_qty': '/hapi/latest/catalog/products-price-qty/',
		'_get_hapi_catalog_product': '/hapi/latest/catalog/product/',
		'_get_hapi_catalog_offer': '/hapi/latest/catalog/offer/%CODE%/',
		'_get_hapi_catalog_speciallist': '/hapi/latest/catalog/speciallist/%CODE%/',
		'_get_hapi_catalog_searchform': '/hapi/latest/catalog/searchform/%CODE%/',
		'_get_hapi_catalog_wishlist': '/hapi/latest/catalog/wishlist/%ID-CODE%/',
		'_get_hapi_catalog_my_wishlist': '/hapi/latest/catalog/wishlist/my/',
		'_get_hapi_catalog_wishlist_categories': '/hapi/latest/catalog/wishlist-categories/%ID-CODE%/',
		'_get_hapi_catalog_my_wishlist_categories': '/hapi/latest/catalog/wishlist-categories/my/',
		'_post_hapi_catalog_wishlist': '/hapi/latest/catalog/wishlist/',
		'_delete_hapi_catalog_wishlist': '/hapi/latest/catalog/wishlist/',
		'_post_hapi_catalog_wishlist_order': '/hapi/latest/catalog/wishlist-order/',
		'_get_hapi_catalog_currency': '/hapi/latest/catalog/currency/',
		'_post_hapi_catalog_currency': '/hapi/latest/catalog/currency/',
		'_get_hapi_catalog_compare': '/hapi/latest/catalog/compare/',
		'_post_hapi_catalog_compare': '/hapi/latest/catalog/compare/',
		'_delete_hapi_catalog_compare': '/hapi/latest/catalog/compare/',
		'_get_hapi_generate_cart_url_to_b2b': '/hapi/latest/webshop/generate-cart-url-to-pa/?app_token_id=%APP_TOKEN_ID%&code=%CODE%',
		'_get_hapi_generate_cart_qr_to_b2b': '/hapi/latest/webshop/generate-cart-qr-to-pa/?app_token_id=%APP_TOKEN_ID%&code=%CODE%',
		'_get_hapi_generate_cart_url_to_web': '/hapi/latest/webshop/generate-cart-url-to-web/?app_token_id=%APP_TOKEN_ID%&code=%CODE%',
		'_get_hapi_generate_cart_qr_to_web': '/hapi/latest/webshop/generate-cart-qr-to-web/?app_token_id=%APP_TOKEN_ID%&code=%CODE%',
		'_get_hapi_copy_cart': '/hapi/latest/webshop/copy-cart/%IDENTIFICATOR%/',
		'_post_hapi_email_cart_to_customer': '/hapi/latest/webshop/email-quick-cart-to-customer/',
		'_post_hapi_webshop_possible_delivery_list': '/hapi/latest/webshop/possible-delivery-list/',
		'_post_hapi_webshop_reset_delivery': '/hapi/latest/webshop/reset-delivery/',
		'_post_hapi_webshop_complaint': '/hapi/latest/webshop/complaint/',
		'_put_hapi_webshop_complaint': '/hapi/latest/webshop/complaint/',
		'_delete_hapi_webshop_complaint': '/hapi/latest/webshop/complaint/',
		'_get_hapi_webshop_complaints': '/hapi/latest/webshop/complaints/',
		'_get_hapi_webshop_show_complaint': '/hapi/latest/webshop/complaint/%IDENTIFICATOR%/',
		'_post_hapi_webshop_api_complaint': '/hapi/latest/webshop/api-complaint/',
		'_post_hapi_catalog_alternative_products': '/hapi/latest/catalog/alternative-products/',
		'_post_hapi_catalog_products_qty': '/hapi/latest/catalog/products-qty/',
		'_get_hapi_catalog_promotion_calendar': '/hapi/latest/catalog/promotion-calendar/%CODE%/',
		'_post_hapi_webshop_package_type': '/hapi/latest/webshop/package-type/',
		'_get_hapi_webshop_extend_reservation': '/hapi/latest/webshop/extend-reservation/',
		'_delete_hapi_webshop_cancel_reservation': '/hapi/latest/webshop/cancel-reservation/',
		'_post_hapi_misc_file_upload': '/hapi/latest/misc/file-upload/',
		'_delete_hapi_misc_file': '/hapi/latest/misc/file/',
		'_post_hapi_webshop_cart_import_from_file': '/hapi/latest/webshop/cart-import-from-file/',
		'_post_hapi_search_autocomplete': '/hapi/latest/search/autocomplete/',
		'_post_hapi_search_search_data': '/hapi/latest/search/search-data/',
		'_get_hapi_sweepstake_pages': '/hapi/latest/sweepstake/pages/',
		'_post_hapi_sweepstake_participant': '/hapi/latest/sweepstake/participant/',
		'_get_hapi_usermessage_threads': '/hapi/latest/usermessage/threads/',
		'_get_hapi_usermessage_thread': '/hapi/latest/usermessage/thread/%ID%/',
		'_post_hapi_usermessage_send': '/hapi/latest/usermessage/send/',
		'_post_hapi_usermessage_reply': '/hapi/latest/usermessage/reply/',
		'_post_hapi_usermessage_upload_attachment': '/hapi/latest/usermessage/attachment/',
		'_delete_hapi_usermessage_delete_thread': '/hapi/latest/usermessage/thread/',
		'_get_hapi_usermessage_form': '/hapi/latest/usermessage/form/%TYPE%/',
		'_post_hapi_misc_event_web': '/hapi/v1/misc/event-web/',
		'_get_hapi_webshop_purchase_termination_order': '/hapi/latest/webshop/purchase-termination-order/%ID%-%CODE%/',
		'_post_hapi_webshop_purchase_termination_lookup': '/hapi/latest/webshop/purchase-termination-lookup/',
		'_post_hapi_webshop_purchase_termination': '/hapi/latest/webshop/purchase-termination/',
		'_get_hapi_auth_my_webshoporder_status_statistics': '/hapi/latest/auth/my-webshoporder-status-statistics/',
	},
});
